var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cfbb24ed3df5239e6ba5df2355ae1a16985d9616"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-web@token-traxx"]={id:"cfbb24ed3df5239e6ba5df2355ae1a16985d9616"};
      